// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + ".legacy." + "4934dffa13c181a17875" + ".js";
};